/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rte_Heading3Inputs */



/**
* | output |
* | --- |
* | "Heading 3" |
*
* @param {Rte_Heading3Inputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const rte_heading3 = /** @type {((inputs?: Rte_Heading3Inputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rte_Heading3Inputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Kop 3")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Titre 3")
	return /** @type {LocalizedString} */ ("Heading 3")
});